import moment from 'moment';
import { compose, setDisplayName, withHandlers, withPropsOnChange } from 'recompose';
import { connect } from 'react-redux';
import { debounce } from 'lodash';
import { generateUrlString, nullFunc, getUrlPatternParamsOmitLast } from '../../utils/helpers';
import { appointmentValidate } from '../actions';
import WithCost from './withCost';
import WithTimeWaitingList from '../../hoc/WithTimeWaitingList';
import { getGiftCardEnabled, getShopId } from '../../shops/selectors';
import { getBarberId } from '../../barbers/selectors';
import { getIsFormValid, getPromoCode, getUser } from '../selectors';
import config from '../../../config';
import { getSelectedServicesForValidate, getServiceDuration } from '../../services/selectors';
import withRouteParameters from './withRouteParameters';

const getValidationTipSettings = (props) => {
  // backend validation returns default tip instead of 0 for kiosk
  // since we don't send kiosk flag there, so they don't know the difference
  if (props.kiosk) {
    return {
      tipAmount: 0,
      tip: 0,
    };
  }
  return {
    tipAmount: props.tipAmount,
    tip: (props.activeTip && !props.activeTip.flat) ? props.activeTip.value : null,
    useFlatTips: !!props.activeTip && !!props.activeTip.flat,
  };
};

const executeValidation = props => (
  props.appointmentValidate({
    ...props.customer,
    shopId: props.shopId,
    barberId: props.barberId,
    promoCode: props.promoCode,
    includeWaitingListFee: props.timeWaitingList,
    dateTime: props.dateTime,
    services: props.services,
    duration: props.duration,
    fallbackUrl: props.fallbackUrl,
    appointmentId: props.appointmentId,
    ...getValidationTipSettings(props),
  }, props.giftCardEnabled)
);

const debouncedValidation = debounce(executeValidation, 500, { leading: true, trailing: true });


export const ValidateAppointmentContainer = compose(
  setDisplayName('ValidateAppointment'),
  withRouteParameters,
  WithCost,
  WithTimeWaitingList,
  connect(
    (state, ownProps) => ({
      shopId: getShopId(state, ownProps.shopRoute),
      barberId: getBarberId(state, ownProps.barberRoute),
      promoCode: getPromoCode(state),
      customer: getIsFormValid(state) ? getUser(state) : undefined,
      giftCardEnabled: getGiftCardEnabled(state, ownProps.shopRoute),
      dateTime: moment(ownProps.reservationTime, config.timeSlugFormat).toJSON(),
      services: getSelectedServicesForValidate(state, ownProps.serviceId),
      duration: getServiceDuration(state, ownProps.serviceId),
      fallbackUrl: generateUrlString(
        getUrlPatternParamsOmitLast(ownProps.params, ownProps.urlPattern),
        ownProps.urlPattern
      ),
    }),
    { appointmentValidate }
  ),
  withHandlers({
    validate: props => () => executeValidation(props),
  }),
  withPropsOnChange(
    ['shopId', 'barberId', 'promoCode', 'tipAmount'],
    (props) => {
      debouncedValidation(props);
    }
  ),
);

export default ValidateAppointmentContainer(nullFunc);



// WEBPACK FOOTER //
// ./src/app/reservation/containers/ValidateAppointment.js